import { type Company } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchCurrentCompany(context: ApiContext) {
  return apiContextFetch<Company>(context, `company`)
}

export function updateCompany(
  context: ApiContext,
  updates: Partial<Company> & {
    logoFile?: File
    remove_logo?: boolean
    darkModeLogoFile?: File
    remove_dark_mode_logo?: boolean
    regenerate_branding?: boolean
  }
) {
  const { logoFile, remove_logo, darkModeLogoFile, remove_dark_mode_logo, ...companyUpdates } = updates

  if (logoFile || darkModeLogoFile) {
    const formData = new FormData()

    if (logoFile) formData.append("company[logo]", logoFile)
    if (darkModeLogoFile) formData.append("company[dark_mode_logo]", darkModeLogoFile)

    Object.entries(companyUpdates).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(`company[${key}]`, value.toString())
      }
    })

    return apiContextFetch<Company>(context, `company`, {
      method: "PUT",
      body: formData,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        "Content-Type": undefined as any,
      },
    })
  } else {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payload: any = { ...companyUpdates }
    if (remove_logo) payload.remove_logo = true
    if (remove_dark_mode_logo) payload.remove_dark_mode_logo = true

    return apiContextFetch<Company>(context, `company`, {
      method: "PUT",
      body: JSON.stringify({ company: payload }),
    })
  }
}

export function regenerateCompanyVoiceProfile(context: ApiContext) {
  return apiContextFetch<{ ai_generating_profile_at: string }>(context, `company/regenerate_voice_profile`, {
    method: "POST",
  })
}
